import React, {useEffect, useState} from 'react';
import SPEARTable from "./SPEARTable";
import PageWithHeader from "../common/PageWithHeader";
import LoadingCover from "../common/LoadingCover";
import {useGetEmployeeReviewByIdQuery, useGetUserByIdQuery} from "../../redux/vmsApi";
import {Box, Button, Paper, Typography} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useRouter } from '../../hooks/useRouter';
import {useParams} from "react-router-dom";

const AdminSPEAR: React.FC = () => {
  const params = useParams();
  const router = useRouter();
  const [employeeId, setEmployeeId] = useState('');
  const { data: reviewData, isLoading } = useGetEmployeeReviewByIdQuery({ id: params?.uuid ?? "" });
  const { data: userData, isLoading: userIsLoading, refetch: refetchUser } = useGetUserByIdQuery({ id: employeeId });

  useEffect(() => {
    if (reviewData?.userId) {
      setEmployeeId(reviewData.userId);
      refetchUser();
    }
  }, [reviewData, refetchUser]);

  if (isLoading || userIsLoading || !reviewData || !userData) {
    return <LoadingCover />;
  }

  return (
    <PageWithHeader>
      <Box padding={5}>
        <Button color="primary" onClick={() => router.push('/reviews/admin')}>
          <ArrowBackIcon/>
          <Typography color="primary" align="left">Admin Dashboard</Typography>
        </Button>
        <Paper elevation={3} sx={{ padding: 10 }}>
          <SPEARTable reviewData={reviewData} userData={userData} admin />
        </Paper>
      </Box>
    </PageWithHeader>
  )
}

export default AdminSPEAR;